enum NotificationToScreen {
  TransactionDetails = "TransactionDetails",
  RequestStatus = "RequestStatus",
  InvoiceDetails = "InvoiceDetails",
  ContactDetails = "ContactDetails",
  PaymentDetails = "PaymentDetails",
  CardDetail = "CardDetail",
}

export default NotificationToScreen;
